import React from "react";
import { Highlight, Snippet } from "react-instantsearch-dom";
import { Link } from "gatsby";
import Typography from "@material-ui/core/Typography";
import translate from "../../utils/translate";

export const DocsHit = clickHandler => ({ hit }) => {
  return (
    <Link to={`/${hit.type}/${hit.slug}/`} onClick={clickHandler}>
      <h4>
        <Highlight attribute="title" hit={hit} tagName="mark" />
      </h4>
      <Typography className="hit__type">{translate(hit.type)}</Typography>
      <Snippet attribute="excerpt" hit={hit} tagName="mark" />
    </Link>
  );
};
